import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {Button, Input} from 'semantic-ui-react';
import {PayPalButton} from 'react-paypal-button-v2';

import {productFormation} from '../../organisms/MainShop/constants';
import getMessage from '../../global/getMessage';

import OrderCompletedModal from './OrderCompletedModal';
import OrderError from './OrderError';

import ProductController from './ProductController';

// eslint-disable-next-line no-unused-vars
const sandbox = 'AXdQ8WL1b52-FIT3OLV79klJl3t3ejtxDmOe9HvlVdzbrRQxWwqhm5BGl-SX4wt_q0Ra6twVp898jQy9';
// eslint-disable-next-line no-unused-vars
const prodbox = 'AeKTNsaSOIDyYKpTMttpXCeTlBT7gCwW-pR3HwlBKWzGILSPeMPA-5NYEe9v866pFaIGqXHED8tuut5T';

const propTypes = {
  createPayment  : PropTypes.func.isRequired,
  currency       : PropTypes.string.isRequired,
  id             : PropTypes.number.isRequired,
  onButtonReady  : PropTypes.func,
  price          : PropTypes.number.isRequired,
  lang           : PropTypes.shape({menu: PropTypes.object}).isRequired,
  sendOrderEmail : PropTypes.func.isRequired,
  toggleLoader   : PropTypes.func.isRequired,
};

const defaultProps = {onButtonReady: undefined};

class Payment extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      error                : null,
      newPrice             : null,
      promo                : '',
      transactionInProcess : false,
      order                : {},
      userEmail            : null,
    };
    this.onHandleCreateOrder = this.onHandleCreateOrder.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleOnError = this.handleOnError.bind(this);
    this.handleClickPromo = this.handleClickPromo.bind(this);
    this.handleOnSuccess = this.handleOnSuccess.bind(this);
    this.handleOnApprove = this.handleOnApprove.bind(this);
    this.handleOnCancel = this.handleOnCancel.bind(this);
    this.handleOnCloseOrder = this.handleOnCloseOrder.bind(this);
    this.handleOnCloseOrderError = this.handleOnCloseOrderError.bind(this);
  }

  handleOnError(error) {
    this.setState({
      transactionInProcess : false,
      error                : error.message,
    });
    this.props.toggleLoader(false);
  }

  onHandleCreateOrder(data, actions) {
    const {
      currency,
      id,
      lang,
    } = this.props;
    const {promo} = this.state;
    this.setState({
      transactionInProcess : true,
      error                : null,
      userEmail            : null,
    });
    this.props.toggleLoader(true);
    return this.props.createPayment(actions, id, lang, currency, promo);
  }

  handleOnCancel() {
    this.setState({transactionInProcess: false});
    this.props.toggleLoader(false);
  }

  handleInput(e, {value}) {
    this.setState({promo: value});
  }

  handleClickPromo() {
    const {promo} = this.state;
    const {id, currency, lang} = this.props;
    const {
      price,
      priceEuro,
      promoCode,
    } = productFormation(lang)[id];
    if (promoCode) {
      const promoValue = promoCode.find((p) => p.code === promo);
      if (promoValue) {
        const pr = currency === '$' ? price : priceEuro;
        const percent = 1 - (promoValue.rebate / 100);
        const newPrice = Math.floor(pr * percent) || 0.01;
        this.setState({newPrice: newPrice});
      }
      else if (!promo) {
        this.setState({newPrice: null});
      }
      else {
        this.setState({error: 'No promo code exists with: ' + promo});
      }
    }
    else {
      this.setState({error: 'No promo code exists with: ' + promo});
    }
  }

  // Not in use
  handleOnSuccess(details, data) {
    const {price, toggleLoader, sendOrderEmail} = this.props;
    const {newPrice} = this.state;
    this.setState({
      transactionInProcess : false,
      error                : null,
    });
    toggleLoader(false);
    sendOrderEmail(details, data, this.props.id, newPrice || price);
  }

  handleOnApprove(data, actions) {
    const {lang, id} = this.props;
    const {title} = productFormation(lang)[id];

    // Capture the funds from the transaction
    actions.order
      .capture()
      .then((details) => {
        const {
          status,
          payer : {email_address, payer_id, name},
          purchase_units: [mainPurchase, ...rest],
        } = details;
        rest; // Not in use

        const {
          amount: {value, currency_code},
          payments: {captures: [{id:transactionID}, ...otherCaptures]},
        } = mainPurchase;
        otherCaptures; // Not in use

        const data = {
          status,
          customerEmail : email_address,
          payer_id,
          customerName  : name,
          price         : value,
          currency      : currency_code,
          transactionID,
        };

        this.setState({
          transactionInProcess : false,
          order                : {
            amount      : `${value}${currency_code}`,
            productName : title[0],
            orderNumber : transactionID,
          },
          userEmail: email_address,
        }, () => {
          console.log('Transaction completed by ', data);
          this.props.sendOrderEmail(data, id);
        });
      })
      .catch((err) => {
        this.setState({error: err});
      });
  }

  handleOnCloseOrder() {
    this.setState({order: {}});
  }

  handleOnCloseOrderError() {
    this.setState({error: null});
  }

  render() {
    const {currency, lang, onButtonReady, price} = this.props;
    const {promo, newPrice, order, error, userEmail} = this.state;

    const propsPaypal = {
      createOrder : this.onHandleCreateOrder,
      onError     : this.handleOnError,
      onApprove   : this.handleOnApprove,
      onCancel    : this.handleOnCancel,
      options     : {
        clientId       : prodbox,
        disableFunding : 'paylater,credit,card',
        currency       : currency === '$' ? 'USD' : 'EUR',
      },
      onButtonReady,
    };

    const actionInput = (
      <Button
        className='Promo-submit'
        color='teal'
        content='Submit'
        onClick={this.handleClickPromo}
      />
    );

    return (
      <div className='MainShop_product_price'>
        <div className='Price-input'>
          <div className={classnames('price',{'promo-price': Boolean(newPrice)})}>
            {`${getMessage('section.shop.actions.price', lang)} ${currency === '$' ? '$' : ''}${newPrice || price}${currency === '$' ? '' : '€'}`}
          </div>
          <Input
            action={actionInput}
            className='Input-promo'
            onChange={this.handleInput}
            placeholder='Promo code...'
            type='text'
            value={promo}
          />
        </div>
        <div className='paypal-button-gaelle'>
          <PayPalButton
            {...propsPaypal}
            style={{
              size  : 'small',
              color : 'white',
              shape : 'pill',
              label : 'checkout',
            }}
          />
        </div>

        <Input
          action={actionInput}
          className='Input-promo-mobile'
          onChange={this.handleInput}
          placeholder='Promo code...'
          type='text'
          value={promo}
        />
        <OrderCompletedModal
          amount={order.amount}
          email={userEmail}
          lang={lang}
          onClose={this.handleOnCloseOrder}
          open={Object.keys(order).length > 0}
          orderNumber={order.orderNumber}
          product={order.productName}
        />
        <OrderError
          email={userEmail}
          error={error}
          lang={lang}
          onClose={this.handleOnCloseOrderError}
          open={Boolean(error)}
        />
      </div>
    );
  }

}

Payment.propTypes = propTypes;

Payment.defaultProps = defaultProps;

export default ProductController(Payment);



// WEBPACK FOOTER //
// ./src/molecules/Product/Payment.js